module.exports = __webpack_public_path__ + "img/capterra.ec228dce.png";